const boardTypeOptions = [
  {value: "INITIATIVE", label: "Tashabbus"},
  {value: "MY_ROAD", label: "Mening yo'lim"},
  {value: "MY_QUARTER", label: "Mening mahallam"},
  {value: "MY_GARDEN", label: "Mening bog'im"},
  {value: "KINDERGARDEN", label: "Bog'cha"},
];

const boardTypeLabels = boardTypeOptions.reduce((acc, item) => {
  acc[item.value] = item.label;
  return acc;
}, {});

const boardDeputyRequiredTypes = ["INITIATIVE", "MY_GARDEN"];

const boardTitleLangKeys = ["uz_lat", "uz_cyr", "ru", "en", "kr"];

const boardTitleLangLabels = {
  uz_lat: "O'zbekcha (lotin)",
  uz_cyr: "Ўзбекча (кирилл)",
  ru: "Русский",
  en: "English",
  kr: "Qoraqalpoqcha",
};

const boardStageOptions = [
  {value: "PREPARE", label: "Tayyorgarlik"},
  {value: "ACCEPT", label: "Qabul qilish"},
  {value: "REVIEW", label: "Ko'rib chiqish"},
  {value: "PROMOTION", label: "Promotion"},
  {value: "VOTE", label: "Ovoz berish"},
  {value: "DEPUTY", label: "Deputat"},
  {value: "FINAL", label: "Yakunlangan"},
];

const boardStageLabels = boardStageOptions.reduce((acc, item) => {
  acc[item.value] = item.label;
  return acc;
}, {});

const boardStageTagTypes = {
  PREPARE: "info",
  ACCEPT: "primary",
  REVIEW: "warning",
  PROMOTION: "warning",
  VOTE: "success",
  DEPUTY: "success",
  FINAL: "info",
};

export {
  boardTypeOptions,
  boardTypeLabels,
  boardDeputyRequiredTypes,
  boardTitleLangKeys,
  boardTitleLangLabels,
  boardStageOptions,
  boardStageLabels,
  boardStageTagTypes,
};
